import { Ref } from "react";

import { maxLengthCallback } from "common/utils";

import BaseInput, { InputProps } from "./BaseInput";

export type TextInputProps = InputProps & {
  /** The text to display, filling up the input if the value isn't set, and shifted up above the value if it is */
  label: string;
  /** The HTML input type */
  type?: string;
  /** The max number of characters supported */
  maxLength?: number;
  /** Called when the control is blurred by clicking outside */
  onBlur?: () => void;
  ref?: Ref<HTMLInputElement>;
};

/** String input generally used for short text strings.
 * @see TextArea for longer free-form text
 */
const TextInput = ({
  type = "text",
  maxLength,
  label,
  className,
  onBlur,
  ref,
  ...other
}: TextInputProps) => {
  return (
    <BaseInput
      styles={{ container: className }}
      {...other}
      renderInputDisplay={({ onChange, preIcon, status, ...inputProps }) => (
        <>
          {preIcon}
          <BaseInput.AnimationContainer label={label}>
            <input
              {...inputProps}
              placeholder="" // Disable placeholders since the label sticks there when value is empty
              ref={ref}
              type={type}
              onChange={(event) => maxLengthCallback(event.target.value, maxLength, onChange)}
              onBlur={onBlur}
            />
          </BaseInput.AnimationContainer>
          {status}
        </>
      )}
    />
  );
};

export default TextInput;
